export default __webpack_public_path__ + "static/modal-pattern-a38e875c4c1b609be9924b0359d3c237.svg";